"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newLinesToHtmlBr = void 0;
// Convert new line characters to HTML <br /> tags
var newLinesToHtmlBr = function newLinesToHtmlBr(html) {
  return html.replaceAll('\n', '<br />');
};
exports.newLinesToHtmlBr = newLinesToHtmlBr;